// Center of Metro Vancouver (Downtown)
const CENTRAL_HUB = {
    lat: 49.2827,
    lng: -123.1207
};

// Maximum Service Radius in km
const MAX_RADIUS_KM = 45;

/**
 * Calculates distance between two points using Haversine formula
 * @param {number} lat1 
 * @param {number} lon1 
 * @param {number} lat2 
 * @param {number} lon2 
 * @returns {number} Distance in kilometers
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
};

function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

export const isWithinServiceArea = (lat, lng) => {
    const distance = calculateDistance(
        CENTRAL_HUB.lat,
        CENTRAL_HUB.lng,
        lat,
        lng
    );
    return distance <= MAX_RADIUS_KM;
};
